module.exports = __webpack_public_path__ + "static/icon-e9560b4af28341bf7ee3e5dc4adcb072.png";